import { ICandidate, IPipelineColumn } from 'Models';

export const dummyCareers = [
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Full-time',
    applications: 42,
    status: 'Draft',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Frontend Engineer',
    department: 'Engineer',
    location: 'Remote',
    type: 'Full-time',
    applications: 42,
    status: 'Published',
    posted: '2026-06-05T09:00:00',
  },
  {
    id: '1',
    jobTitle: 'Senior Product Designer',
    department: 'Product',
    location: 'Lagos / Hybrid',
    type: 'Part-time',
    applications: 42,
    status: 'Closed',
    posted: '2026-06-05T09:00:00',
  },
]


export const resReq =
  'Bachelor\'s degree or HND in Business Administration,  Accounting, Finance, or Economics\nFresh graduates/NYSC corps members, or up to 1–2 years experience\nPrior experience in fuel retail or forecourt operations is an advantage'


export const pipelineColumns: IPipelineColumn[] = [
  {
    id: 'APPLIED',
    title: 'Applied',
  },
  {
    id: 'SCREENING',
    title: 'Screening',
  },
  {
    id: 'SHORTLISTED',
    title: 'Shortlisted',
  },
  {
    id: 'INTERVIEW',
    title: 'Interview',
  },
  {
    id: 'OFFER',
    title: 'Offer',
  },
  {
    id: 'HIRED',
    title: 'Hired',
  },
];

export const dummyCandidates: ICandidate[] = [
  {
    id: 1,
    name: 'Nnamdi Obiora1',
    position: 'Sr. Product Designer',
    appliedDate: 'Sep 12',
    stage: 'APPLIED',
  },
  {
    id: 2,
    name: 'Nnamdi Obiora2',
    position: 'UI/UX Designer',
    appliedDate: 'Sep 12',
    stage: 'APPLIED',
  },
  {
    id: 3,
    name: 'Nnamdi Obiora3',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'APPLIED',
  },
  {
    id: 4,
    name: 'Nnamdi Obiora4',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'APPLIED',
  },
  {
    id: 5,
    name: 'Nnamdi Obiora5',
    position: 'Sr. Product Designer',
    appliedDate: 'Sep 12',
    stage: 'SCREENING',
  },
  {
    id: 6,
    name: 'Nnamdi Obiora6',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'SCREENING',
  },
  {
    id: 7,
    name: 'Nnamdi Obiora7',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'SHORTLISTED',
  },
  {
    id: 8,
    name: 'Nnamdi Obiora8',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'SHORTLISTED',
  },
  {
    id: 9,
    name: 'Nnamdi Obiora9',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'SHORTLISTED',
  },
  {
    id: 10,
    name: 'Nnamdi Obiora10',
    position: 'Nnamdi Obiora',
    appliedDate: 'Sep 12',
    stage: 'INTERVIEW',
  },
  {
    id: 11,
    name: 'Nnamdi Obiora11',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'OFFER',
  },
  {
    id: 12,
    name: 'Nnamdi Obiora12',
    position: 'Product Designer',
    appliedDate: 'Sep 12',
    stage: 'HIRED',
  },
];